import { ThemeFontContent } from "../molecule/themeFontContent"
import { ThemeColorContent } from "../molecule/themeColorContent"
import { ThemeStyleContent } from "../molecule/themeStyleContent"
import { ThemeBrandingContent } from "../molecule/themeBrandingContent"
import { ThemeTitleContent } from "../molecule/themeTitleContent"


export const ThemeContentFactory = ({setting,setData,data}) => { 
    switch(setting){
        case 1 :return <ThemeFontContent fonts={data} fontData={(value) => setData(value)}/>
        case 2: return <ThemeColorContent colors={data} setColor={(value) => setData(value)}/>
        case 3: return  <ThemeStyleContent styles={data} setStyle={(value) => setData(value)}/>
        case 4: return  <ThemeBrandingContent branding={data} setLogo={(value) => setData(value)}/>
        case 5: return  <ThemeTitleContent titles={data} setTitleContent={(value) => setData(value)}/>
    }

}